import { formatDate } from '@angular/common';
import {
  DataTableColumnTextProps,
  DataTableColumnVariant,
  DataTableRowActions,
  DataTableVariant,
  DynamicDataTable,
  DynamicDataTableColumn,
} from '../../../components/data-table-builder/data-table.types';
import { CurrentTasksRepository } from '../../../store/current-tasks-state/current-tasks-state.repository';

interface getCurrentTasksDataTableStructureProps {
  store: CurrentTasksRepository;
  rowActionsFn: () => DataTableRowActions;
}

export const getCurrentTasksDataTableStructure = ({ store, rowActionsFn }: getCurrentTasksDataTableStructureProps): DynamicDataTable => {
  const taskIdColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'currentTasks.table.taskId',
    accessorKey: 'taskId',
    variant: DataTableColumnVariant.TEXT,
  };

  const tenantIdColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'currentTasks.table.tenantId',
    accessorKey: 'tenantId',
    variant: DataTableColumnVariant.TEXT,
  };

  const taskRefColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'currentTasks.table.entityRef',
    accessorKey: 'ref',
    variant: DataTableColumnVariant.TEXT,
  };

  const createdByColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'currentTasks.table.entityName',
    accessorKey: 'nom',
    variant: DataTableColumnVariant.TEXT,
    class: 'truncate w-[10vw] min-w-0',
  };

  const taskNameColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'currentTasks.table.taskName',
    accessorKey: 'taskName',
    variant: DataTableColumnVariant.TEXT,
  };

  const createdAtColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'currentTasks.table.createdAt',
    accessorKey: 'created',
    variant: DataTableColumnVariant.TEXT,
    renderAs: (value: string) => {
      return {
        value: formatDate(value, 'dd/MM/yyyy HH:mm', 'en-US'),
      };
    },
  };

  return {
    singular: 'Activité',
    plural: 'Activités',
    data: [],
    columns: [taskIdColumn, tenantIdColumn, taskRefColumn, taskNameColumn, createdByColumn, createdAtColumn],
    variant: DataTableVariant.COMMON,
    sizes: [10, 20, 50],
    stripedRows: true,
    target: row => {
      store.setNested('response', row);
    },
    rowActionsFn,
    searchableFields: ['taskName', 'taskId', 'ref', 'nom'],
  };
};
